import Helper from '../utils/helper.js'

class BandNews {
  init () {
    const bandElement = $('.band-news')
    const bandIdentifiant = bandElement.data('identifiant')

    console.log('bandElement', bandElement)
    console.log('bandIdentification', bandIdentifiant)

    if (bandElement.length > 0 && bandIdentifiant) {
      const userCookie = Helper.getCookie('user')
      console.log('userCookie', userCookie)
      if (userCookie !== bandIdentifiant) {
        $('.band-news-close').on('click', function () {
          bandElement.hide()
          Helper.setCookie('user', bandIdentifiant, Number.MAX_SAFE_INTEGER)
        })
      } else {
        bandElement.hide()
      }
    }
  }
}

export default BandNews
